<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <div class="container-fluid">
                <form id="FormMateriales" role="form" method="post" autocomplete="off" onSubmit="return false">
                    <CList @FiltrarC="Recuperar" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
                        <template slot="Filtros">
                            <div class="col-auto">
                                <label class="col-form-label text-primary">Por</label>
                            </div>
                            <div class="col-auto">
                                <select @change="Recuperar" v-model="Filtro.IdArticuloCategoria" class="form-select form-control-search">
                                    <option value="0">Todos</option>
                                    <option v-for="(item,index) in Categorias" :key="index" :value="item.IdArticuloCategoria">{{item.Nombre}}</option>
                                </select>
                            </div>
                        </template>

                        <template slot="header">
                            <th :class="StyleTh+' text-center'">#</th>
                            <th :class="StyleTh">Nombre</th>
                            <th :class="StyleTh">Categoría</th>
                            <th :class="StyleTh">Elegir</th>
                        </template>

                        <template slot="body">
                            <tr v-for="(lista,index) in Materiales" :key="index">
                                <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                                <td><h6 :class="StylePr">{{lista.Nombre}}</h6></td>
                                <td><p :class="StyleTd">{{ lista.Categoria }}</p></td>
                                <td v-if="BndMostrarBotones">
                                    <button v-show="lista.ShowButton" @click="SeleccionarMaterial(lista)" type="button" class="btn btn-link text-primary px-3 mb-0 mr-1"><i class="fas fa-check-circle text-primary"></i> Agregar</button>
                                </td>
                            </tr>
                            <CSinRegistros :pContIF="Materiales.length" :pColspan="4"></CSinRegistros>
                        </template>
                    </CList>
                </form>
            </div>
        </template>
    </CLoader>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';
export default {
    name: 'FormMateriales',
    props:['poBtnSave','pMaterialesSeleccionados','pIdProveedor'],
    data() {
        return {
            ConfigLoad:{
                ShowLoader: false,
                ClassLoad: false,
            },
            Emit: this.poBtnSave.EmitSeccion,
            ConfigList:{
                Title:'Materiales',
                BtnNewShow:false,
                ShowTitleFirst: false,
                ShowLoader: false,
                ShowFooter:false
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                IdArticuloCategoria: 0,
            },
            segurity: {},
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            BndMostrarBotones:true,
            Materiales:[],
            Categorias:[]
        }
    },
    methods: {
        Recuperar(){
            this.ConfigList.ShowLoader=true;
            this.$http.get('materialespresentacionproveedor/materiales',
            {
                params:{
                    Nombre: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    IdArticuloCategoria:this.Filtro.IdArticuloCategoria,
                    IdProveedor:this.pIdProveedor
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                // this.Materiales=res.data.data.data;
                let arreglo=res.data.data.data.map((el)=>{
                    el.Unidades=[];
                    el.SubUnidades=[];
                    el.PrecioUnitario="";
                    el.Importe="";
                    el.Cantidad="";
                    el.IdUnidad="";
                    el.Unidad="";
                    el.SubUnidad="";
                    el.Descripcion="";
                    el.IdSubUnidad="";
                    el.ShowButton=true;
                    return el});
                this.Materiales=arreglo;
                this.FiltrarBoton();
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
                this.ConfigLoad.ShowLoader = false;
            });
        },
        SeleccionarMaterial(item){
            this.bus.$emit('SeleccionarMaterial',item);
        },
        FiltrarBoton(){
            if (this.pMaterialesSeleccionados.length>0) {
                this.Materiales.forEach(element => {
                    let BndCambio=this.pMaterialesSeleccionados.some((el)=>{return el.IdArticuloAlmacen==element.IdArticuloAlmacen});
                    if (BndCambio) {
                        element.ShowButton=false;
                    }
                });
            }
            this.BndMostrarBotones=true;
        },
        ListaCategorias(){
            this.$http.get('articulosCategoria', {
                params: {
                    simple: 1,
                    TipoCategoria: 'Producto',
                }
            }).then((res) => {
                this.Categorias = res.data.data;
            });

            /* this.$http.get("productosCategoria/simple"
            ).then((res)=>{
                this.Categorias=res.data.data
            }) */
        }
    },
    created() {
        this.ListaCategorias();
        this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            // this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;
            this.Recuperar();
        });
    },
}
</script>

<style>

</style>